/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightBookingThreeDsResumeRequest
 */
export interface FlightBookingThreeDsResumeRequest {
    /**
     *
     * @type {string}
     * @memberof FlightBookingThreeDsResumeRequest
     */
    bookingRequestId: string;
    /**
     *
     * @type {string}
     * @memberof FlightBookingThreeDsResumeRequest
     */
    actionId: string;
}

/**
 * Check if a given object implements the FlightBookingThreeDsResumeRequest interface.
 */
export function instanceOfFlightBookingThreeDsResumeRequest(value: object): value is FlightBookingThreeDsResumeRequest {
    if (!('bookingRequestId' in value) || value['bookingRequestId'] === undefined) return false;
    if (!('actionId' in value) || value['actionId'] === undefined) return false;
    return true;
}

export function FlightBookingThreeDsResumeRequestFromJSON(json: any): FlightBookingThreeDsResumeRequest {
    return FlightBookingThreeDsResumeRequestFromJSONTyped(json, false);
}

export function FlightBookingThreeDsResumeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightBookingThreeDsResumeRequest {
    if (json == null) {
        return json;
    }
    return {

        'bookingRequestId': json['booking_request_id'],
        'actionId': json['action_id'],
    };
}

export function FlightBookingThreeDsResumeRequestToJSON(json: any): FlightBookingThreeDsResumeRequest {
    return FlightBookingThreeDsResumeRequestToJSONTyped(json, false);
}

export function FlightBookingThreeDsResumeRequestToJSONTyped(value?: FlightBookingThreeDsResumeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'booking_request_id': value['bookingRequestId'],
        'action_id': value['actionId'],
    };
}
